import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AnnonceService } from '../annonce.service';
declare var $: any;

@Component({
  selector: 'app-add-annonce',
  templateUrl: './add-annonce.component.html',
  styleUrls: ['./add-annonce.component.scss']
})
export class AddAnnonceComponent implements OnInit {
  @ViewChild('descriptionTextarea', { static: false }) descriptionTextarea!: ElementRef;
  @ViewChild('annoncePhotoInput', { static: false }) annoncePhotoInput!: ElementRef;
  @ViewChild('multiplePhotosInput', { static: false }) multiplePhotosInput!: ElementRef;

  annonceData: {
    Annonce: string;
    AnnonceName: string;
    adresse: string;
    appartement: string;
    description: string;
    emailuser: string;
    nom: string;
    numero: string[];
    prix: string;
    surface: string;
    ville: string;
    Annoncephoto: string;
    photos: string[];
    isApproved: string;
    Vu: any;
  } = {
    Annonce: '',
    AnnonceName: '',
    adresse: '',
    appartement: '',
    description: '',
    emailuser: '',
    nom: '',
    numero: ['', ''],
    prix: '',
    surface: '',
    ville: '',
    Annoncephoto: '',
    photos: [],
    isApproved: 'true',
    Vu: 'true'
  };

  // For custom city
  customCity: string = '';
  showCustomCityInput: boolean = false;

  selectedAnnoncephoto: File | null = null;
  selectedPhotos: File[] = [];
  uploadedAnnoncePhoto: string | null = null;
  uploadedPhotos: string[] = [];
  
  public categoryInput: string = '';
  public categories: string[] = [];
  public isLoading: boolean = false;

  // List of all Tunisian governorates
  tunisianCities: string[] = [
    'Tunis', 'Ariana', 'Ben Arous', 'Manouba',
    'Nabeul', 'Zaghouan', 'Bizerte', 'Béja',
    'Jendouba', 'Kef', 'Siliana', 'Sousse',
    'Monastir', 'Mahdia', 'Sfax', 'Kairouan',
    'Kasserine', 'Sidi Bouzid', 'Gabès', 'Médenine',
    'Tataouine', 'Gafsa', 'Tozeur', 'Kébili'
  ];

  constructor(private annonceService: AnnonceService, private router: Router) { }

  ngOnInit(): void {
    if (!this.annonceData.numero || this.annonceData.numero.length === 0) {
      this.annonceData.numero = ['', ''];
    }
  }

  // Called when city selection changes
  onCitySelect(value: string): void {
    if (value === 'Autre') {
      this.showCustomCityInput = true;
      this.customCity = ''; // reset custom input
      this.annonceData.ville = 'Autre'; // keep as placeholder
    } else {
      this.showCustomCityInput = false;
      this.customCity = '';
      this.annonceData.ville = value;
    }
  }

  // Ouvrir le sélecteur de fichiers pour l'image principale
  openAnnoncePhotoSelector(): void {
    if (this.annoncePhotoInput && this.annoncePhotoInput.nativeElement) {
      this.annoncePhotoInput.nativeElement.click();
    }
  }

  // Ouvrir le sélecteur de fichiers pour les images multiples
  openMultiplePhotosSelector(): void {
    if (this.multiplePhotosInput && this.multiplePhotosInput.nativeElement) {
      this.multiplePhotosInput.nativeElement.click();
    }
  }

  // Génération de chaîne aléatoire pour les noms de fichiers
  public getRandomString(length: any) {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  // Formatage du texte dans la description
  formatText(command: string): void {
    if (this.descriptionTextarea && this.annonceData.description) {
      const textarea = this.descriptionTextarea.nativeElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.annonceData.description.substring(start, end);
      
      let formattedText = '';
      switch (command) {
        case 'bold':
          formattedText = `<strong>${selectedText}</strong>`;
          break;
        case 'italic':
          formattedText = `<em>${selectedText}</em>`;
          break;
        case 'underline':
          formattedText = `<u>${selectedText}</u>`;
          break;
        case 'list':
          formattedText = `<ul><li>${selectedText}</li></ul>`;
          break;
      }
      
      const newText = this.annonceData.description.substring(0, start) + 
                     formattedText + 
                     this.annonceData.description.substring(end);
      
      this.annonceData.description = newText;
      
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + formattedText.length, start + formattedText.length);
      }, 0);
    }
  }

  // Gestion des catégories
  addCategory(): void {
    if (this.categoryInput && this.categoryInput.trim() !== '') {
      if (!this.categories.includes(this.categoryInput.trim())) {
        this.categories.push(this.categoryInput.trim());
      }
      this.categoryInput = '';
    }
  }

  removeCategory(category: string): void {
    const index = this.categories.indexOf(category);
    if (index >= 0) {
      this.categories.splice(index, 1);
    }
  }

  // Handle main image selection for Annoncephoto
  onAnnoncephotoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.selectedAnnoncephoto = input.files[0];
      this.uploadAnnoncePhoto();
    }
  }

  // Handle group of images selection for photos
  onPhotosSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.selectedPhotos = Array.from(input.files);
      this.uploadPhotos();
    }
  }

  // Upload main image and show preview
  async uploadAnnoncePhoto(): Promise<void> {
    if (!this.selectedAnnoncephoto) return;

    this.isLoading = true;
    
    try {
      const renamedFile = new File([this.selectedAnnoncephoto], 
        `${this.getRandomString(10)}_${Date.now()}_${this.selectedAnnoncephoto.name}`, 
        { type: this.selectedAnnoncephoto.type }
      );

      const imageUrl = await this.annonceService.uploadPhoto(renamedFile);
      
      this.uploadedAnnoncePhoto = imageUrl;
      this.annonceData.Annoncephoto = imageUrl;
      
      Swal.fire({
        icon: "success",
        title: "Image principale ajoutée",
        text: "L'image principale a été uploadée avec succès",
        timer: 2000,
        showConfirmButton: false
      });
      
    } catch (err: any) {
      console.error('Error uploading main image:', err);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Échec du téléchargement de l'image principale.",
      });
    } finally {
      this.isLoading = false;
    }
  }

  // Upload multiple images and show previews
  async uploadPhotos(): Promise<void> {
    if (!this.selectedPhotos.length) return;

    this.isLoading = true;
    
    Swal.fire({
      title: 'Upload en cours...',
      html: 'Veuillez patienter pendant le téléchargement des images',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const renamedFiles = this.selectedPhotos.map(file => {
        return new File([file], 
          `${this.getRandomString(10)}_${Date.now()}_${file.name}`, 
          { type: file.type }
        );
      });

      const imageUrls = await this.annonceService.uploadPhotos(renamedFiles);
      
      Swal.close();
      
      this.uploadedPhotos = [...this.uploadedPhotos, ...imageUrls];
      this.annonceData.photos = [...this.annonceData.photos, ...imageUrls];
      
      if (imageUrls.length > 0) {
        Swal.fire({
          icon: "success",
          title: `${imageUrls.length} images ajoutées`,
          text: "Toutes les images ont été uploadées avec succès",
          timer: 3000,
          showConfirmButton: false
        });
      }
      
    } catch (error: any) {
      Swal.close();
      console.error('Error uploading multiple images:', error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Échec du téléchargement des images. Veuillez réessayer.",
      });
    } finally {
      this.isLoading = false;
    }
  }

  // Supprimer l'image principale
  removeAnnoncePhoto(): void {
    if (!this.uploadedAnnoncePhoto) return;

    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer l'image principale?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.annonceService.deletePhoto(this.uploadedAnnoncePhoto!).then(success => {
          if (success) {
            this.uploadedAnnoncePhoto = null;
            this.annonceData.Annoncephoto = '';
            this.selectedAnnoncephoto = null;
            
            Swal.fire({
              icon: "success",
              title: "Image supprimée",
              text: "L'image principale a été supprimée avec succès",
              timer: 1500,
              showConfirmButton: false
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: "Échec de la suppression de l'image principale",
            });
          }
        }).catch(error => {
          console.error('Error deleting main image:', error);
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Échec de la suppression de l'image principale. Veuillez réessayer.",
          });
        });
      }
    });
  }

  // Supprimer une image multiple
  removePhoto(index: number): void {
    const imageUrl = this.uploadedPhotos[index];
    
    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer cette image?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.annonceService.deletePhoto(imageUrl).then(success => {
          if (success) {
            this.uploadedPhotos.splice(index, 1);
            this.annonceData.photos.splice(index, 1);
            
            Swal.fire({
              icon: "success",
              title: "Image supprimée",
              text: "L'image a été supprimée avec succès",
              timer: 1500,
              showConfirmButton: false
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: "Échec de la suppression de l'image",
            });
          }
        }).catch(error => {
          console.error('Error deleting image:', error);
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Échec de la suppression de l'image. Veuillez réessayer.",
          });
        });
      }
    });
  }

  // Déplacer une image vers le haut
  movePhotoUp(index: number): void {
    if (index > 0) {
      [this.uploadedPhotos[index], this.uploadedPhotos[index - 1]] = 
      [this.uploadedPhotos[index - 1], this.uploadedPhotos[index]];
      
      [this.annonceData.photos[index], this.annonceData.photos[index - 1]] = 
      [this.annonceData.photos[index - 1], this.annonceData.photos[index]];
    }
  }

  // Déplacer une image vers le bas
  movePhotoDown(index: number): void {
    if (index < this.uploadedPhotos.length - 1) {
      [this.uploadedPhotos[index], this.uploadedPhotos[index + 1]] = 
      [this.uploadedPhotos[index + 1], this.uploadedPhotos[index]];
      
      [this.annonceData.photos[index], this.annonceData.photos[index + 1]] = 
      [this.annonceData.photos[index + 1], this.annonceData.photos[index]];
    }
  }

  // Validation du formulaire – updated with custom city validation
  validateForm(): boolean {
    // Check if city is selected
    if (!this.annonceData.ville || this.annonceData.ville.trim() === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Champ requis',
        text: 'Veuillez sélectionner une ville',
        confirmButtonColor: '#3f51b5'
      });
      return false;
    }

    // If "Autre" is selected, custom city must be filled
    if (this.annonceData.ville === 'Autre') {
      if (!this.customCity || this.customCity.trim() === '') {
        Swal.fire({
          icon: 'warning',
          title: 'Champ requis',
          text: 'Veuillez saisir le nom de votre ville',
          confirmButtonColor: '#3f51b5'
        });
        return false;
      }
      // Replace 'Autre' with the custom city for submission
      this.annonceData.ville = this.customCity.trim();
    }

    const requiredFields = [
      { field: this.annonceData.Annonce, message: 'Veuillez sélectionner le type d\'annonce' },
      { field: this.annonceData.AnnonceName, message: 'Veuillez saisir un titre' },
      { field: this.annonceData.adresse, message: 'Veuillez saisir une adresse' },
      { field: this.annonceData.appartement, message: 'Veuillez sélectionner le type de bien' },
      { field: this.annonceData.description, message: 'Veuillez saisir une description' },
      { field: this.annonceData.numero[0], message: 'Veuillez saisir un numéro de téléphone principal' },
      { field: this.annonceData.nom, message: 'Veuillez saisir votre nom' },
      { field: this.annonceData.Annoncephoto, message: 'Veuillez télécharger une image principale' }
    ];

    for (const field of requiredFields) {
      if (!field.field || field.field.toString().trim() === '') {
        Swal.fire({
          icon: 'warning',
          title: 'Champ requis',
          text: field.message,
          confirmButtonColor: '#3f51b5'
        });
        return false;
      }
    }
    
    // Validate phone number format
    const phoneRegex = /^[0-9]{8}$/;
    if (!phoneRegex.test(this.annonceData.numero[0])) {
      Swal.fire({
        icon: 'warning',
        title: 'Numéro invalide',
        text: 'Le numéro de téléphone principal doit contenir 8 chiffres',
        confirmButtonColor: '#3f51b5'
      });
      return false;
    }
    
    return true;
  }

  // Handle form submission
  async onSubmit(): Promise<void> {
    if (this.isLoading) {
      Swal.fire({
        icon: 'warning',
        title: 'Veuillez patienter',
        text: 'Des images sont en cours de téléchargement',
        confirmButtonColor: '#3f51b5'
      });
      return;
    }

    if (!this.validateForm()) {
      return;
    }

    this.isLoading = true;
    
    Swal.fire({
      title: 'Traitement en cours...',
      html: 'Publication de votre annonce',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });
    
    try {
      if (this.categories.length > 0) {
        this.annonceData.description += '\n\nCaractéristiques: ' + this.categories.join(', ');
      }

      this.annonceService.createAnnonce(this.annonceData).subscribe({
        next: (response) => {
          Swal.close();
          this.showNotification('top', 'right', 'success', 'Annonce ajoutée avec succès!');
          this.resetForm();
          this.isLoading = false;
          
          setTimeout(() => {
            this.router.navigate(['/annonce']);
          }, 2000);
        },
        error: (error) => {
          Swal.close();
          console.error('Error creating announcement:', error);
          this.showNotification('top', 'right', 'danger', 'Échec de l\'ajout de l\'annonce');
          this.isLoading = false;
        }
      });
    } catch (error: any) {
      Swal.close();
      console.error('Error in form submission:', error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Une erreur est survenue lors de la soumission du formulaire',
        confirmButtonColor: '#3f51b5'
      });
      this.isLoading = false;
    }
  }

  // Reset form fields after submission
  private resetForm(): void {
    this.annonceData = {
      Annonce: '',
      AnnonceName: '',
      adresse: '',
      appartement: '',
      description: '',
      emailuser: '',
      nom: '',
      numero: ['', ''],
      prix: '',
      surface: '',
      ville: '',
      Annoncephoto: '',
      photos: [],
      isApproved: 'true',
      Vu: 'true'
    };
    this.customCity = '';
    this.showCustomCityInput = false;
    this.selectedAnnoncephoto = null;
    this.selectedPhotos = [];
    this.uploadedAnnoncePhoto = null;
    this.uploadedPhotos = [];
    this.categories = [];
    this.categoryInput = '';
    
    if (this.annoncePhotoInput && this.annoncePhotoInput.nativeElement) {
      this.annoncePhotoInput.nativeElement.value = '';
    }
    if (this.multiplePhotosInput && this.multiplePhotosInput.nativeElement) {
      this.multiplePhotosInput.nativeElement.value = '';
    }
  }

  // Notification function
  showNotification(from: string, align: string, type: string, message: string): void {
    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 3000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
    });
  }

  // Navigation back
  navigateBack(): void {
    this.router.navigate(['/annonce']);
  }
}